import "core-js/modules/es.error.cause.js";
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-d917394a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "coupon_details"
};
const _hoisted_2 = {
  class: "base_details_content"
};
const _hoisted_3 = {
  class: "content"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "基本信息", -1));

const _hoisted_5 = {
  class: "base_details_content_second"
};
const _hoisted_6 = {
  class: "base_details_date_picker"
};
const _hoisted_7 = {
  class: "base_details_date_picker"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "日内", -1));

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "优惠设置", -1));

const _hoisted_10 = {
  class: "base_details_content_second"
};
const _hoisted_11 = {
  class: "money_box"
};

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "满", -1));

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "元，减", -1));

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "元", -1));

const _hoisted_15 = {
  class: "money_box"
};

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "折", -1));

const _hoisted_17 = {
  class: "money_box"
};

const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "抵扣", -1));

const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "元", -1));

const _hoisted_20 = {
  class: "money_box"
};

const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "元可购买", -1));

const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "适用商品", -1));

const _hoisted_23 = {
  class: "base_details_content_second"
};
const _hoisted_24 = {
  style: {
    "margin-bottom": "20px"
  }
};
const _hoisted_25 = {
  style: {
    "margin-bottom": "20px"
  }
};
const _hoisted_26 = {
  class: "base_screen_header"
};
const _hoisted_27 = {
  class: "dialog-footer"
};
import BackTitleView from "@com/BackTitleView.vue";
import { ref, reactive } from "vue";
import { $box, $msg } from "@ui/msg";
import $ from "@util/base";
import api from "@api/coupon";
import productApi from "@api/productChoose";
import useRoute from "@util/router";
import DataCollectTable from "@/components/table/DataCollectTable.vue";
import { COLUMN_TYPE, OP_KEY, OPERATIONS, operationsHander } from "@/components/table/tableOperations";
import { Search } from "@element-plus/icons-vue";
export default {
  __name: 'CouponDetails',

  setup(__props) {
    const route = useRoute();
    const urlQuery = route.query();
    var readOnly = false;
    var updateOnly = false;
    var title = "优惠券详情";
    $.handleCRU(urlQuery.type, {
      show: () => {
        readOnly = true;
        title = "优惠券详情";
        getData();
      },
      add: () => {
        title = "新增优惠券";
      },
      modify: () => {
        readOnly = true;
        updateOnly = true;
        title = "修改优惠券";
        getData();
      }
    }); // const otherUnit = ref();
    // const unitOptions = ["个", "份", "箱", "其他"];

    const moneyTypeOptions = [{
      label: "满减",
      value: "1010001"
    }, {
      label: "折扣",
      value: "1010002"
    }, {
      label: "抵扣",
      value: "1010003"
    }, {
      label: "指定金额",
      value: "1010004"
    }];
    const basicFormRef = ref(null);
    const discountsFormRef = ref(null);
    const discountGoodsFormRef = ref(null);
    const couponForm = ref({
      name: null,
      date: [],
      limitBusiType: null,
      moneyType: "1010001",
      limitMoney: null,
      money: null,
      lifespanType: '1059001',
      applyType: '1060001',
      busiTypes: [],
      busiType: '',
      itemList: [],
      claimDateNum: null,
      isOneBuy: 0,
      mainTitle: null,
      subtitle: null
    });

    const checkMoneyOff = (rule, value, callback) => {
      if ($.isNull(couponForm.value.limitMoney) || $.isNull(couponForm.value.money)) {
        callback(new Error("请输入优惠内容"));
      }

      return true;
    };

    const couponRules = {
      name: [{
        required: true,
        message: "请输入优惠券名称",
        trigger: "blur"
      }],
      date: [{
        required: true,
        type: "array",
        message: "请选择有效期",
        trigger: "change"
      }],
      claimDateNum: [{
        required: true,
        message: "请输入领取日期",
        trigger: "blur"
      }],
      mainTitle: [{
        min: 0,
        max: 4,
        message: '主标题长度在 0 到 4 个字符',
        trigger: 'blur'
      }],
      subtitle: [{
        min: 0,
        max: 7,
        message: '副标题长度在 0 到 7 个字符',
        trigger: 'blur'
      }],
      limitBusiType: [{
        required: true,
        message: "请选择适用品类",
        trigger: "change"
      }],
      moneyType: [{
        required: true,
        message: "请选择优惠形式",
        trigger: "change"
      }],
      moneyOff: [{
        required: true,
        validator: checkMoneyOff,
        trigger: "blur"
      }],
      money: [{
        required: true,
        message: "请输入优惠内容",
        trigger: "blur"
      }],
      busiTypes: [{
        required: true,
        message: "请选择适用品类",
        trigger: "change"
      }]
    };
    const applyTypeOptions = [{
      label: "单个商品",
      value: "1060001"
    }, {
      label: "多个商品",
      value: "1060002"
    }, {
      label: "全部分类",
      value: "1060003"
    }];
    const busiTypeOptions = [{
      label: "全部商城产品",
      value: "1003001"
    }, {
      label: "全部旅行产品",
      value: "1003002"
    }, {
      label: "全部酒店产品",
      value: "1003003"
    }]; //1061001旅行 1061002酒店 1061003商品 1061004礼包

    const typeOptions = [{
      label: "商品",
      value: "1061003",
      fun: "productSku"
    }, {
      label: "酒店",
      value: "1061002",
      fun: "hotelRoom"
    }, {
      label: "旅行",
      value: "1061001",
      fun: "travelPackage"
    }, {
      label: "综合活动",
      value: "1061004",
      fun: "giftPackage"
    }];
    const couponDetailGoodsTableRef = ref(null);
    const couponDetailGoodsDataConfig = ref({
      showIndex: true,
      operations: {
        label: '操作',
        width: 200,
        operations: getOperations
      },
      column: [{
        label: "排序",
        prop: "sort",
        type: COLUMN_TYPE.input,
        operationsKey: OPERATIONS.input,
        width: 80
      }, {
        label: "产品图片",
        prop: "mainPic",
        type: COLUMN_TYPE.picture,
        width: 100
      }, {
        label: "产品名称",
        prop: "name",
        width: 200
      }, {
        label: "产品sku",
        prop: "childName"
      }, {
        label: "产品编号",
        prop: "code",
        width: 100
      }]
    });

    function getOperations(data) {
      return [OPERATIONS.del];
    }

    const productDataTableRef = ref(null);
    const addProductDialog = ref(false);
    const productTableIf = ref(false);
    const productData = ref([]);
    const productName = ref("");
    const productType = ref("商品");
    const productTypeKey = ref("productSku");
    const productTypeValue = ref("1061003");
    const productDataConfig = ref({
      showIndex: true,
      showSelection: true,
      column: [{
        label: "产品图片",
        prop: "mainPic",
        type: COLUMN_TYPE.picture,
        width: 100
      }, {
        label: "产品名称",
        prop: "name"
      }, {
        label: "产品sku",
        prop: "childName"
      }, {
        label: "产品编号",
        prop: "code",
        width: 100
      }, {
        label: "产品分类",
        prop: "category",
        width: 100
      }]
    });
    const couponDetailGoodsOpHandler = operationsHander();
    const opHander = operationsHander();
    const size = ref(20);
    const page = ref(1);
    const total = ref(0);

    function typeOptionsChange(item) {
      console.log(typeOptions);
      console.log(item);
      typeOptions.find(e => {
        if (e.label === item) {
          productTypeKey.value = e.fun;
          productTypeValue.value = e.value;
          productType.value = e.label;
          getProductData();
        }
      });
    }

    function showAddProduct() {
      getProductData();
      addProductDialog.value = true;
    }

    function getProductData() {
      productApi.chooseList(productTypeKey.value, {
        name: productName.value,
        page: page.value,
        size: size.value
      }, val => {
        productData.value = val.itemList;
        total.value = val.total;
      });
    }

    function pageChange(type, val) {
      if (type == 'page') {
        page.value = val;
      } else if (type == 'size') {
        size.value = val;
      }

      getProductData();
    }

    function productDataSelectedSubmit() {
      let selectedData = productDataTableRef.value.getSelectData();

      if ($.isEmpty(selectedData)) {
        $msg.error("请勾选需要添加的产品");
      } else if (selectedData.length > 0 && couponForm.value.itemList.length > 0 && couponForm.value.applyType === '1060001') {
        $msg.error("只能选择一个产品");
      } else {
        // typeOptions.find((e) => {
        //   if (e.label === productType.value) {
        //     couponForm.value.itemList = selectedData;
        //     addProductDialog.value = false;
        //   }
        // })
        //改动为可以添加多种
        selectedData.filter(e => {
          const eCode = e.childrenCode || e.code;
          return !couponForm.value.itemList.some(s => {
            const sCode = s.childrenCode || s.code;
            return eCode === sCode;
          });
        }).map(m => {
          m.type = typeOptions.find(e => e.label === productType.value).value;
          return m;
        }).forEach(e => {
          couponForm.value.itemList.push(e);
        });
        addProductDialog.value = false;
      }
    }

    couponDetailGoodsOpHandler.install(OP_KEY.delete, (data, row) => {
      $box.open("移除", "确认移除产品" + data.name, () => {
        if (data.childrenCode) {
          let index = couponForm.value.itemList.findIndex(e => {
            return e.childrenCode === data.childrenCode;
          });
          couponForm.value.itemList.splice(index, 1);
        } else {
          let index = couponForm.value.itemList.findIndex(e => {
            return e.code === data.code;
          });
          couponForm.value.itemList.splice(index, 1);
        }
      });
    });

    function check() {
      let check = [false, false];
      let p1 = basicFormRef.value.validate(valid => {
        if (valid) {
          check[0] = true;
        } else {
          check[0] = false;
        }
      });
      let p2 = discountsFormRef.value.validate(valid => {
        if (valid) {
          check[1] = true;
        } else {
          check[1] = false;
        }
      });
      let p3 = discountGoodsFormRef.value.validate(valid => {
        if (valid) {
          check[2] = true;
        } else {
          check[2] = false;
        }
      });
      Promise.all([p1, p2, p3]).then(() => {
        if (check.every(function (e) {
          return e;
        })) {
          saveForm();
        }
      });
    }

    function saveForm() {
      $.handleCRU(route.query().type, {
        add: () => {
          save();
        },
        modify: () => {
          update();
        }
      });
    }

    function update() {
      let data = {};
      Object.assign(data, couponForm.value); // if (data.date.length > 0) {
      //   data.startDate = data.date[0]
      //   data.endDate = data.date[1]
      // }
      // delete data.date

      if (data.itemList.length > 0) {
        if (data.itemList.length > 1 && couponForm.value.applyType === '1060001') {
          $msg.error("只能选择一个产品");
          return;
        }

        data.itemList = data.itemList.map((e, index) => {
          return {
            type: e.type,
            code: e.code,
            childrenCode: e.childrenCode,
            sort: e.sort || index + 1
          };
        });
      }

      api.update(data, () => {
        $msg.succ("修改成功");
        route.go(-1);
      });
    }

    function save() {
      let data = {};
      Object.assign(data, couponForm.value);

      if (data.date.length > 0) {
        data.startDate = data.date[0];
        data.endDate = data.date[1];
      }

      delete data.date;

      if (data.itemList.length > 0) {
        if (data.itemList.length > 1 && couponForm.value.applyType === '1060001') {
          $msg.error("只能选择一个产品");
          return;
        }

        data.itemList = data.itemList.map((e, index) => {
          return {
            type: e.type,
            code: e.code,
            childrenCode: e.childrenCode,
            sort: e.sort || index + 1
          };
        });
      }

      api.add(data, () => {
        $msg.succ("新增成功");
        route.go(-1);
      });
    }

    function getData() {
      api.details(urlQuery.code, val => {
        if (val.startDate && val.endDate) {
          val.date = [val.startDate, val.endDate];
        }

        couponForm.value = val;

        if (val.busiType) {
          couponForm.value.busiTypes = valueToOptions(val.busiType);
        }
      });
    }

    function busiTypeOptionChange(val) {
      const busiType = [];
      val.forEach(e => {
        busiTypeOptions.forEach(item => {
          if (item.label === e) {
            busiType.push(item.value);
          }
        });
      });
      couponForm.value.busiType = busiType.join(",");
    }

    function valueToOptions(value) {
      const vs = value.split(",");
      const label = [];
      vs.forEach(v => {
        busiTypeOptions.forEach(item => {
          if (item.value === v) {
            label.push(item.label);
          }
        });
      });
      return label;
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_checkbox = _resolveComponent("el-checkbox");

      const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");

      const _component_el_switch = _resolveComponent("el-switch");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_main = _resolveComponent("el-main");

      const _component_el_footer = _resolveComponent("el-footer");

      const _component_el_container = _resolveComponent("el-container");

      const _component_el_radio_button = _resolveComponent("el-radio-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, {
        class: "base_details_container"
      }, {
        default: _withCtx(() => [_createVNode(BackTitleView, {
          title: _unref(title)
        }, null, 8, ["title"]), _createVNode(_component_el_main, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_form, {
            ref_key: "basicFormRef",
            ref: basicFormRef,
            disabled: _unref(readOnly),
            model: couponForm.value,
            rules: couponRules,
            "label-width": "100px",
            class: "base_details_form"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "优惠券名称",
              prop: "name"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: couponForm.value.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => couponForm.value.name = $event),
                placeholder: "请输入"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "有效期",
              prop: "lifespanType"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                modelValue: couponForm.value.lifespanType,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => couponForm.value.lifespanType = $event)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_radio, {
                  label: "1059001"
                }, {
                  default: _withCtx(() => [_createTextVNode("规定范围")]),
                  _: 1
                }), _createVNode(_component_el_radio, {
                  label: "1059002"
                }, {
                  default: _withCtx(() => [_createTextVNode("领取日起")]),
                  _: 1
                }), _createVNode(_component_el_radio, {
                  label: "1059003"
                }, {
                  default: _withCtx(() => [_createTextVNode("长期有效")]),
                  _: 1
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), couponForm.value.lifespanType === '1059001' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "",
              prop: "date"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_date_picker, {
                modelValue: couponForm.value.date,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => couponForm.value.date = $event),
                type: "daterange",
                "range-separator": "~",
                "start-placeholder": "开始日期",
                "end-placeholder": "结束日期",
                "value-format": "YYYY-MM-DD"
              }, null, 8, ["modelValue"])])]),
              _: 1
            })) : _createCommentVNode("", true), couponForm.value.lifespanType === '1059002' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 1,
              label: "",
              prop: "claimDateNum"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_input, {
                modelValue: couponForm.value.claimDateNum,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => couponForm.value.claimDateNum = $event)
              }, null, 8, ["modelValue"]), _hoisted_8])]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["disabled", "model"])]), _hoisted_9, _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_form, {
            ref_key: "discountsFormRef",
            ref: discountsFormRef,
            model: couponForm.value,
            disabled: _unref(readOnly),
            rules: couponRules,
            "label-width": "100px",
            class: "base_details_form"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "优惠形式",
              prop: "moneyType"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                modelValue: couponForm.value.moneyType,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => couponForm.value.moneyType = $event)
              }, {
                default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(moneyTypeOptions, (item, index) => {
                  return _createVNode(_component_el_radio, {
                    key: index,
                    label: item.value
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
                    _: 2
                  }, 1032, ["label"]);
                }), 64))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), couponForm.value.moneyType === '1010001' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "优惠内容",
              prop: "moneyOff"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_hoisted_12, _createVNode(_component_el_input, {
                modelValue: couponForm.value.limitMoney,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => couponForm.value.limitMoney = $event),
                placeholder: "请输入"
              }, null, 8, ["modelValue"]), _hoisted_13, _createVNode(_component_el_input, {
                modelValue: couponForm.value.money,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => couponForm.value.money = $event),
                placeholder: "请输入"
              }, null, 8, ["modelValue"]), _hoisted_14])]),
              _: 1
            })) : couponForm.value.moneyType === '1010002' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 1,
              label: "优惠内容",
              prop: "money"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_createVNode(_component_el_input, {
                modelValue: couponForm.value.money,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => couponForm.value.money = $event),
                placeholder: "例如：9.8"
              }, null, 8, ["modelValue"]), _hoisted_16])]),
              _: 1
            })) : couponForm.value.moneyType === '1010003' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 2,
              label: "优惠内容",
              prop: "money"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_17, [_hoisted_18, _createVNode(_component_el_input, {
                modelValue: couponForm.value.money,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => couponForm.value.money = $event),
                placeholder: "请输入"
              }, null, 8, ["modelValue"]), _hoisted_19])]),
              _: 1
            })) : couponForm.value.moneyType === '1010004' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 3,
              label: "优惠内容",
              prop: "money"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_20, [_createVNode(_component_el_input, {
                modelValue: couponForm.value.money,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => couponForm.value.money = $event),
                placeholder: "请输入"
              }, null, 8, ["modelValue"]), _hoisted_21])]),
              _: 1
            })) : _createCommentVNode("", true), couponForm.value.moneyType === '1010004' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 4,
              label: "主标题",
              prop: "mainTitle"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: couponForm.value.mainTitle,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => couponForm.value.mainTitle = $event),
                placeholder: "请输入"
              }, null, 8, ["modelValue"])]),
              _: 1
            })) : _createCommentVNode("", true), couponForm.value.moneyType === '1010004' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 5,
              label: "副标题",
              prop: "subtitle"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: couponForm.value.subtitle,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => couponForm.value.subtitle = $event),
                placeholder: "请输入"
              }, null, 8, ["modelValue"])]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["model", "disabled"])]), _hoisted_22, _createElementVNode("div", _hoisted_23, [_createVNode(_component_el_form, {
            ref_key: "discountGoodsFormRef",
            ref: discountGoodsFormRef,
            model: couponForm.value,
            disabled: _unref(readOnly),
            rules: couponRules,
            "label-width": "100px",
            class: "base_details_form"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "适用商品",
              prop: "applyType"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                modelValue: couponForm.value.applyType,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => couponForm.value.applyType = $event)
              }, {
                default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(applyTypeOptions, (item, index) => {
                  return _createVNode(_component_el_radio, {
                    key: index,
                    label: item.value
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
                    _: 2
                  }, 1032, ["label"]);
                }), 64))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), couponForm.value.applyType == '1060003' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "",
              prop: "busiTypes"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_checkbox_group, {
                modelValue: couponForm.value.busiTypes,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => couponForm.value.busiTypes = $event),
                onChange: busiTypeOptionChange
              }, {
                default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(busiTypeOptions, (item, index) => {
                  return _createVNode(_component_el_checkbox, {
                    key: index,
                    label: item.label,
                    "model-value": item.value
                  }, null, 8, ["label", "model-value"]);
                }), 64))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
              label: "指定件数",
              prop: "num"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: couponForm.value.num,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => couponForm.value.num = $event),
                placeholder: "请输入"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), couponForm.value.applyType == '1060001' || couponForm.value.applyType == '1060002' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 1,
              label: "是否可多件购买",
              prop: "isOneBuy",
              "label-width": "300"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_switch, {
                modelValue: couponForm.value.isOneBuy,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => couponForm.value.isOneBuy = $event),
                "active-value": 1,
                "inactive-value": 0
              }, null, 8, ["modelValue"])]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["model", "disabled"]), _createVNode(_component_el_form, {
            ref_key: "discountGoodsFormRef",
            ref: discountGoodsFormRef,
            model: couponForm.value,
            rules: couponRules,
            "label-width": "100px",
            class: "base_details_form"
          }, {
            default: _withCtx(() => [couponForm.value.applyType == '1060001' || couponForm.value.applyType == '1060002' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "",
              prop: "itemList"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_24, [_createVNode(_component_el_button, {
                type: "primary",
                onClick: showAddProduct
              }, {
                default: _withCtx(() => [_createTextVNode("添加产品")]),
                _: 1
              })]), _createVNode(DataCollectTable, {
                ref_key: "couponDetailGoodsTableRef",
                ref: couponDetailGoodsTableRef,
                data: couponForm.value.itemList,
                config: couponDetailGoodsDataConfig.value,
                isRoute: false,
                isPage: false,
                onOperationsHander: _unref(couponDetailGoodsOpHandler).receive
              }, null, 8, ["data", "config", "onOperationsHander"])]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["model"])])])])]),
          _: 1
        }), _createVNode(_component_el_footer, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            onClick: _cache[16] || (_cache[16] = $event => _unref(route).go(-1))
          }, {
            default: _withCtx(() => [_createTextVNode("取消")]),
            _: 1
          }), !_unref(readOnly) || _unref(updateOnly) ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            onClick: check,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("保存 ")]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_dialog, {
        title: "添加产品",
        modelValue: addProductDialog.value,
        "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => addProductDialog.value = $event),
        width: "80%",
        "destroy-on-close": ""
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_27, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: productDataSelectedSubmit
        }, {
          default: _withCtx(() => [_createTextVNode("保存")]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: _cache[20] || (_cache[20] = $event => addProductDialog.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_25, [_createVNode(_component_el_radio_group, {
          modelValue: productTypeValue.value,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => productTypeValue.value = $event),
          size: "large",
          onChange: typeOptionsChange
        }, {
          default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(typeOptions, item => {
            return _createVNode(_component_el_radio_button, {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]);
          }), 64))]),
          _: 1
        }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_26, [_createVNode(_component_el_form, {
          inline: true,
          class: "base_search_form",
          onSubmit: _cache[19] || (_cache[19] = _withModifiers(() => {}, ["prevent"]))
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: productName.value,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => productName.value = $event),
              "onKeyup[native]": getProductData,
              onChange: getProductData,
              placeholder: "产品名称",
              clearable: "",
              "suffix-icon": _unref(Search)
            }, null, 8, ["modelValue", "suffix-icon"])]),
            _: 1
          })]),
          _: 1
        })]), _createVNode(DataCollectTable, {
          ref_key: "productDataTableRef",
          ref: productDataTableRef,
          data: productData.value,
          config: productDataConfig.value,
          isRoute: false,
          isRadio: couponForm.value.applyType === '1060001',
          onOperationsHander: _unref(opHander).receive,
          total: total.value,
          onPageChange: pageChange
        }, null, 8, ["data", "config", "isRadio", "onOperationsHander", "total"])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }

};